import React from 'react';

//axios
import axios from 'axios';
import axiosUrl from '../../axios/url';

import { Link } from 'react-router-dom';

import Pagination from "react-js-pagination";
//require("bootstrap/less/bootstrap.less");


export default function ContentsTable(param) {

    // 데이터 변수
    // const [selectedContentId, setSelectedContentId] = React.useState('');  //클릭한 콘텐츠 아이디
    const [list , setList] = React.useState([]);                           // 콘텐츠 목록
    const [parentMenu, setParentMenu] = React.useState('');                //콘텐츠 목록을 조회한 메뉴. ( 스케줄 or 콘텐츠 )
    const [keyword, setKeyword] = React.useState('');                      // 검색어
    const [filteredList , setFilteredList] = React.useState([]);           // 검색한 결과 담는 리스트

    // 페이징 변수
    const [activePage, setActivePage] = React.useState(1);                 // 디폴트는 1페이지
    const [itemsCountPerPage, setItemsCountPerPage] = React.useState(7);   // 페이지당 보여질 콘텐츠 개수
    const [pageRangeDisplayed, setPageRangeDisplayed] = React.useState(5); // 하단에 보여질 페이징 숫자 개수
    const [totalItemsCount, setTotalItemsCount] = React.useState(0);

    // 스케줄 페이지에서 목록 클릭시 스케줄 등록 페이지로 이동
    function goScheduleCreate(value){
        param.callbackContent(value);
    }

    const handlePageChange = (pageNumber) => {
        setActivePage(pageNumber);
        newList();

    }

    // 콘텐츠 목록 조회 (페이징 처리 된 목록)
    const newList =  () => {
        return new Promise(function(resolve, reject){
            var type = "";
            if(param.type === "quiz") {
                type = "quizzes";
            } else if(param.type === undefined) {
                type = "blogs";
            } else {
                type = param.type;
            }

            const res =  axios.get(axiosUrl.contents + "/" + type,{
                params:{
                    size: itemsCountPerPage,
                    sort: 'id',
                    order:'desc',
                    page: activePage
                }
            });

            if(res) resolve(res);
            reject(new Error("Request is failed"));
        });
    }

    async function getNewList(){
        var type = "";
        if(param.type === "quiz") {
            type = "quizzes";
        } else if(param.type === undefined) {
            type = "blogs";
        } else {
            type = param.type;
        }

        await axios.get(axiosUrl.contents + "/" + type,{
            params:{
                size: itemsCountPerPage,
                sort: 'id',
                order:'desc',
                page: activePage
            }
        }).then ( res => {
            const result2 = res.data;
            if(JSON.stringify(filteredList) !== JSON.stringify(result2)) { // 기존 리스트와 새 리스트를 비교해서 다를때만 렌더링
                // 검색어를 입력되어 있지 않으면, 전체 목록을 화면에 뿌림
                // if(keyword === '')  
                setFilteredList(result2);
            }
        }).catch(function (e){
            console.error('[MEDIEX_CMS_2019_ERROR] contents.getNewList - ' + e);
        });
    }

    async function getAllList(){
        var type = "";
        if(param.type === "quiz") {
            type = "quizzes";
        }else if(param.type === undefined) {
            type = "blogs";
        } else {
            type = param.type;
        }

        await axios.get(axiosUrl.contents + "/" + type,{
            params:{
                sort: 'id',
                order:'desc',
                page: '-1' // 전체목록 끌어올때는 -1
            }
        }).then ( res => {
            const result1 = res.data;
            if(JSON.stringify(list) !== JSON.stringify(result1)) { // 기존 리스트와 새 리스트를 비교해서 다를때만 렌더링
                setList(result1);
                setTotalItemsCount(result1.length);
            }
        }).catch(function (e){
            console.error('[MEDIEX_CMS_2019_ERROR] contents.getAllList - ' + e);
        });
    }

    // 콘텐츠 목록 조회 (페이징 무관하게 전체 다 가져옴. 검색 기능때문에.)
    const allList =  () => {
        var type = "";
        if(param.type === "quiz") {
            type = "quizzes";
        }else if(param.type === undefined) {
            type = "blogs";
        } else {
            type = param.type;
        }
        return new Promise(function(resolve, reject){
            const res =  axios.get(axiosUrl.contents + "/" + type,{
                params:{
                    sort: 'id',
                    order:'desc',
                    page: '-1' // 전체목록 끌어올때는 -1
                }
            });

            if(res) resolve(res);
            reject(new Error("Request is failed"));
        });
    }

     // 검색어 입력
     function goSearch(e){
        var k = e.target.value;

        setKeyword(k);

        const arr = list.filter(function(item){
            const result = item.title.indexOf(k);
            return result > -1;
        });

        setFilteredList(arr);
        setActivePage(1);
        setTotalItemsCount(arr.length);
    }
    

    function renderItems(){

        if(list.length > 0){
                if(parentMenu === 'CONTENTS'){
                    return filteredList.map( (value, i) => 
                            <tr key={i}> 
                                <td  className="cursor-pointer"  align="center">
                                    {
                                        value.thumbnailUrl !== '' && 
                                                    
                                        <Link to={ "/contents/" + param.type +'modify/' + value.id} >
                                            <img src={value.thumbnailUrl} width="60" height="60"/>
                                        </Link>  
                                            
                                    }
                                </td>
                                <td  className="cursor-pointer"  valign="middle" align="left" >
                                    <Link to={ "/contents/" + param.type +'modify/' + value.id} className="linkBlackColor">
                                        {
                                            value.title
                                        }
                                    </Link>
                                </td>
                                
                            </tr>
                        )
                }else if(parentMenu === 'SCHEDULE'){
                    return filteredList.map( (value, i) =>
                            <tr  key={i}> 
                                <td  className="cursor-pointer"  align="center">
                                    {
                                            value.thumbnailUrl !== '' &&
                                    
                                            <Link onClick={() => goScheduleCreate(value)} data-dismiss="modal" align="center">
                                                <img src={value.thumbnailUrl} width="60" height="60"/>
                                            </Link>
                                            
                                    }
                                </td>
                                <td  className="cursor-pointer" valign="middle" align="left" >
                                    <Link onClick={() => goScheduleCreate(value)} data-dismiss="modal" className="linkBlackColor">
                                        {
                                            value.title
                                        }
                                    </Link>
                                </td>
                            </tr>
                        )
                }
        }else{
            return(
                <tr> 
                    <td  className="cursor-pointer" align="center"></td>
                    <td  className="cursor-pointer" valign="middle" align="left" >조회할 콘텐츠가 없습니다.</td>
                </tr>
            )
        }
    }


    React.useEffect(() => {

        setActivePage(1);
        //setKeyword("");
        //setList([]);
        //주소창 값을 읽어와서 콘텐츠/스케줄 구분함

        const curUrl = window.location.href;
        if( curUrl.indexOf('contents') > -1)  {
            setParentMenu('CONTENTS'); 
        } else {
            setParentMenu('SCHEDULE');
            console.log("content schedule");
        } 

        getAllList();
        getNewList();

        // // 콘텐츠 목록 조회 (페이징 상관없이 전체 목록 - 검색을 위해서 가져옴)
        // allList().then(function (res){
        //     const result1 = res.data;
        //     if(JSON.stringify(list) !== JSON.stringify(result1)) { // 기존 리스트와 새 리스트를 비교해서 다를때만 렌더링
        //         setList(result1);
        //         setTotalItemsCount(result1.length);
        //     }
        // }).catch(function(e){
        //     console.error('[MEDIEX_CMS_2019_ERROR] - ' + e.response.data.error.message);
        // });


        // 콘텐츠 목록 조회 (페이징 처리된 목록)
        // newList().then(function (res){
        //     const result2 = res.data;
        //     if(JSON.stringify(filteredList) !== JSON.stringify(result2)) { // 기존 리스트와 새 리스트를 비교해서 다를때만 렌더링
        //         // 검색어를 입력되어 있지 않으면, 전체 목록을 화면에 뿌림
        //         // if(keyword === '')  
        //         setFilteredList(result2);
                   
        //     }
        // }).catch(function(e){
        //     console.error('[MEDIEX_CMS_2019_ERROR] - ' + e.response.data.error.message);
        // });

    }, [activePage, param.type]);
    

    return(
        <div>
            <div className="col-sm-12">
                <div  className="input-group input-group-sm mr-4 flex-row-reverse">
                    <label className="mr-3 font-weight-normal">Search:
                        <input type="text"  className="form-control tag-filter heifht-31" onChange={goSearch} value={keyword}/>
                    </label>
                </div>
            </div>
            <table id="contentsTable" className="table table-hover">
                <thead align="center">
                    <tr>
                        <th>썸네일</th>
                        <th>제목</th>
                    </tr>
                </thead>
                <tbody>
                    {renderItems()}
                </tbody>
                <tfoot></tfoot>
            </table>

            <div className="col-md-12">
                <div>
                <Pagination
                    activePage={activePage}
                    itemsCountPerPage={itemsCountPerPage}
                    totalItemsCount={totalItemsCount}
                    pageRangeDisplayed={pageRangeDisplayed}
                    onChange={handlePageChange}
                    linkClass="page-link"
                    innerClass="pagination text-center justify-content-center"
                    itemClass="page-item"
                    activeClass="current"
                    linkClassNext="next"
                    linkClassPrev="pre"
                    linkClassFirst="pre"
                    linkClassLast="next"
                    hideDisabled="true"
                />
                </div>
                
            </div>
            
        </div>
        
    );
}
